import { useEffect, useRef, useState } from 'react';
import { triggerImpressionUrl } from '../../../../server/actions/triggerImpressionUrl.js';
export const useImpressionTracker = (impressionUrl) => {
    const [hasFired, setHasFired] = useState(false);
    const elementRef = useRef(null);
    useEffect(() => {
        if (!impressionUrl || !elementRef.current || hasFired) {
            return;
        }
        const observer = new IntersectionObserver(async ([entry]) => {
            if (entry.isIntersecting) {
                await triggerImpressionUrl(impressionUrl);
                setHasFired(true);
                observer.disconnect();
            }
        }, {
            threshold: 0.5,
        });
        observer.observe(elementRef.current);
        return () => observer.disconnect();
    }, [impressionUrl, hasFired]);
    return elementRef;
};
//# sourceMappingURL=useImpressionTracker.js.map